import { render, staticRenderFns } from "./StockingsViewPage.vue?vue&type=template&id=30d61f78&"
import script from "./StockingsViewPage.vue?vue&type=script&lang=js&"
export * from "./StockingsViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports